// src/components/family/familyComponents/FamilyCard.js
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../../firebase-client';
import { useAuth } from '../../../auth/AuthContext';
export default function FamilyCard({
  member,
  currentUser,
  currentUserRole,
  familyId,
  onAction = () => {}
}) {
  const {
    switchToChildAccount,
    switchingAccount
  } = useAuth();
  const [profile, setProfile] = useState(null);
  const [switchError, setSwitchError] = useState('');
  useEffect(() => {
    const fetchProfile = async () => {
      const snap = await getDoc(doc(db, 'users', member.userId));
      setProfile(snap.data());
    };
    fetchProfile();
  }, [member.userId]);
  if (!profile) return null;
  const isParent = member.role === 'parent';
  const isSelf = currentUser === member.userId;
  const isCurrentUserParent = currentUserRole === 'parent';
  const canActOn = isCurrentUserParent && !isSelf && !isParent;
  const isChild = member.role === 'child';
  const handleRemove = async () => {
    const displayName = [profile.firstName, profile.lastName].filter(Boolean).join(' ') || 'this family member';
    const confirm = window.confirm(`Remove ${displayName} from this family? Their family access will end immediately.`);
    if (!confirm) return;
    try {
      const removeFamilyMemberFn = httpsCallable(functions, 'removeFamilyMember');
      await removeFamilyMemberFn({
        familyId,
        memberId: member.userId
      });
      onAction();
    } catch (err) {
      alert('Could not remove family member.');
    }
  };
  const handleSwitch = async () => {
    setSwitchError('');
    try {
      await switchToChildAccount({
        familyId,
        childUid: member.userId
      });
    } catch (err) {
      setSwitchError(err.message || 'Could not switch accounts.');
    }
  };
  return <div className="card">
      <h3 className="card-title">
        {(profile.firstName || '') + ' ' + (profile.lastName || '')}
        {profile.username ? ` (${profile.username})` : ''}
      </h3>
      <p className="card-text">{isParent ? 'Parent' : 'Child'}</p>

      {canActOn && <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    }}>
          {isChild && <button type="button" className="button button-primary" onClick={handleSwitch} disabled={switchingAccount}>
              {switchingAccount ? 'Switching…' : 'Load as this user'}
            </button>}
          <button type="button" className="button button-danger" onClick={handleRemove}>
            Remove from family
          </button>
          {switchError && <p style={{
        margin: 0,
        color: '#c0392b'
      }}>{switchError}</p>}
        </div>}
    </div>;
}
